import {
  CallDetailResultFromAPI,
  Record,
} from "../../types/marginCallsAndAlerts";
import getDateString from "../../utils/getDateString";

export function formatRecord(record: CallDetailResultFromAPI): Record {
  const {
    accountHolderName,
    account,
    eventName,
    callAmount,
    eventCode,
    closedDate,
    correspondentCode,
    dueDate,
    eventId,
    issueDate,
    status,
    tradeDate,
    eventType,
    description,
  } = record;

  return {
    actionMenu: record,
    key: eventId,
    status,
    type: eventType,
    callId: eventId,
    correspondentCode,
    accountId: account,
    accountHolder: accountHolderName,
    callType: eventCode,
    eventName,
    description,
    callAmount,
    tradeDate: getDateString(tradeDate),
    dueDate: getDateString(dueDate),
    closedDate: getDateString(closedDate),
    issueDate: getDateString(issueDate),
  };
}

export default function getRecords(results: CallDetailResultFromAPI[]) {
  return results.map(formatRecord);
}
